export default __webpack_public_path__ + "static/media/01Sanchi.d6fa4561.jpg";